import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { MethodLogosCreate } from './MethodLogosCreate/MethodLogosCreate';
import { MethodLogosEdit } from './MethodLogosEdit/MethodLogosEdit';
import { MethodLogosList } from './MethodLogosList/MethodLogosList';
import { MethodLogosShow } from './MethodLogosShow/MethodLogosShow';

export const methodLogosResource: ResourceProps = {
  name: Resources.MethodLogos,
  create: MethodLogosCreate,
  edit: MethodLogosEdit,
  list: MethodLogosList,
  show: MethodLogosShow,
};
